import {
    HStack, Text, VStack,
} from '@chakra-ui/react';
import { ComponentProps } from 'react';
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { FaIcon } from '../fa-icon';
import { SkeletonMotion } from '../skeleton-motion/skeleton-motion';

function AddressCard({
    address,
    isLoading = false,
    children,
    ...props
}: {
    address: string | undefined;
    isLoading?: boolean;
} & ComponentProps<typeof VStack>) {
    return (
        <VStack
            alignItems="start"
            gap={1}
            borderColor="muted.50"
            borderWidth={1}
            py={4}
            px={4}
            rounded="md"
            bgColor="white"
            {...props}
        >
            <HStack gap={2} fontSize="sm">
                <FaIcon icon={faLocationDot} />
                <Text fontWeight="bold">Property address</Text>
            </HStack>
            {(isLoading || address === undefined)
                && (
                    <SkeletonMotion h={6} />
                )}
            {address !== undefined && (
                <Text>{address}</Text>
            )}
            {address !== undefined && children}
        </VStack>
    );
}

export { AddressCard };
